<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <ViewInsurance title="ข้อมูลประกัน"></ViewInsurance>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ViewInsurance from "./ViewInsurance";
export default {
  name: "customerInsuranceView",
  components: {
    ViewInsurance,
  },
};
</script>
<style scoped></style>
